export default __webpack_public_path__ + "static/media/36.0943cbe9.jpg";